import {
  getAuthHeader,
  graphqlApi,
  handleGraphQLError,
} from '../../../App/services/requests';
import { SubmitSATResultsAcademicDataRequest } from '../../entities';
import { SubmitSATResultsAcademicDataResponse } from '../../entities/SATResultsResponseTypes';

export const submitSATAcademicDataGraphQLCall = async (
  request: SubmitSATResultsAcademicDataRequest,
): Promise<SubmitSATResultsAcademicDataResponse> => {
  const authHeader = (await getAuthHeader()) as any;
  if (Object.keys(authHeader).length > 0) {
    authHeader['x-api-key'] = undefined;
  }

  const response = await graphqlApi.post(
    '',
    {
      variables: {
        input: request,
      },
      query: `
        mutation TeachTapSubmitSATAcademicData($input: TeachTapSubmitSATAcademicDataInput!) {
          teachTapSubmitSATAcademicData(input: $input) {
            success
            message
          }
        }`,
    },
    {
      headers: {
        ...authHeader,
      },
    },
  );

  handleGraphQLError(response);
  return response.data.data?.teachTapSubmitSATAcademicData;
};
